// import { EmployeeList } from "components/Employee";

import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { EmployeeList } from "../../components/EmployeeList";
import { FC } from "react";
import { PayrollEHTEarningList } from "../../components/PayrollEHTEarningList/PayrollEHTEarningList";

export interface IPayrollEHTEarningsListPage {}

export const PayrollEHTEarningsListPage: FC<IPayrollEHTEarningsListPage> = (
  props: IPayrollEHTEarningsListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll EHT Earning"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "", navigateTo: "/payroll-federal-earning/list" },
      ]}
      mainContents={<PayrollEHTEarningList />}
    />
  );
};
